<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="package_list"
          @click="group1.submit"
        >決定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">パッケージを指定</span>
        </div>
        <div class="popup-content">
          <ul class="popup-list">

            <li v-for="item in group1.choices_packages" :key="'choices_packages_' + item.id" class="popup-list-item">
              <div class="formparts checkbox">
                <input v-model="group1.package_ids" :value="item.package_id" 
                  type="checkbox" :id="'package_' + item.id">
                <label :for="'package_' + item.id">{{ item.name }}<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </li>

          </ul>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import * as logicQASearchDetailPackageList from '@/logic/qa/QASearchDetailPackageList'

export default defineComponent({
  props: {
    parentGroup1: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    const group1 = logicQASearchDetailPackageList.getGroup(props, context)

    const close = () => {
      context.emit('closeSearchDetailPackageList')
    }
    const state = reactive({
      isFocusSelect: false
    })

    return {
      group1,
      close,
      state
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content {
    &-1 {
      padding: 20px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid $color-line;
      position: relative;
      z-index: 2;
      .txt {
        display: inline-block;
        font-size: 1.4rem;
      }
      .formparts.select {
        font-size: 1.4rem;
        min-width: 140px;
        margin-left: 20px;
        input[type="text"] {
          width: 140px;
          padding-right: 40px;
        }
      }
    }
  }
  .popup-list {
    position: relative;
    z-index: 1;
  }
</style>
